import {classNames} from "shared/lib/classNames/classNames";
import cls from "./ArrowLink.module.scss";
import {ReactComponent as ArrowButton} from "shared/assets/icons/ArrowButtonsvg.svg";
import {AppLink} from "shared/ui/AppLink/AppLink";

export enum ArrowLinkTheme {
    DOWN = "down",
}

interface ArrowLinkProps {
    className?: string;
    href?: string;
    onClick?: () => void;
    theme?: ArrowLinkTheme;
    color?: string;
}

const ArrowLink = ({className, href , onClick, theme = ArrowLinkTheme.DOWN, color}: ArrowLinkProps) => {
    return (
        <AppLink onClick={onClick} href={href} className={classNames(cls.ArrowLink, {}, [className])}>
            <div className={classNames(cls.ArrowLink__link, {}, [cls[theme]])}>
                <ArrowButton fill={color} />
            </div>
        </AppLink>
    )
};

export default ArrowLink;

